// SMART DEMO — Vista Prime Gayrimenkul asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 apartments + 4 villas + 4 investment + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Vista Prime Gayrimenkul" tamamen kurgu demo markadır.

export const VISTA_PRIME_ASSET_ROOT = "/demo-presets/realestate/vista-prime";

export interface VistaPrimeManifest {
  logo: string;
  apartments: string[];
  villas: string[];
  investment: string[];
  videos: string[];
}

export const VISTA_PRIME_MANIFEST: VistaPrimeManifest = {
  logo: `${VISTA_PRIME_ASSET_ROOT}/logo/logo.webp`,
  apartments: [
    `${VISTA_PRIME_ASSET_ROOT}/apartments/01.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/apartments/02.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/apartments/03.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/apartments/04.webp`,
  ],
  villas: [
    `${VISTA_PRIME_ASSET_ROOT}/villas/01.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/villas/02.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/villas/03.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/villas/04.webp`,
  ],
  investment: [
    `${VISTA_PRIME_ASSET_ROOT}/investment/01.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/investment/02.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/investment/03.webp`,
    `${VISTA_PRIME_ASSET_ROOT}/investment/04.webp`,
  ],
  videos: [
    `${VISTA_PRIME_ASSET_ROOT}/videos/01.mp4`,
    `${VISTA_PRIME_ASSET_ROOT}/videos/02.mp4`,
  ],
};